import React from 'react'

const index = ({value, style}) => {
  return (
    <div className='border-b-[1px] border-solid w-full border-gray-borderinGray'><input className={`border-none w-full outline-none font-sans  h-[32px]  ${style ? style : 'text-[15px] text-gray-inputsGray'}`} type="text" placeholder={value} /></div>
  )
}

export default index